// extracted by mini-css-extract-plugin
export default {"placementListComponent":"PlacementList_placementListComponent__Afx8x"};